module.exports = __webpack_public_path__ + "img/GAME_LIGHTBUG.3023a471.png";